import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { METADATA_QUERY } from '../queries';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import ListBrowser from '@ts-private/list-browser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import { metadataStore } from '../metadataStore';
import { sortBy } from 'utils/functions';
import MetadataDetailsListContainer from './MetadataDetailsListContainer';

const filterParams = (data, pager, filters) => {
  let metadata = [...data];

  if (filters.search)
    metadata = metadata.filter(item => {
      if (item.code && item.code.toLowerCase().trim().includes(filters.search.toLowerCase().trim())) return true;
      if (item.name && item.name.toLowerCase().trim().includes(filters.search.toLowerCase().trim())) return true;
      return false;
    });
  if (filters.name)
    metadata = metadata.filter(item => {
      return item.name && item.name.toLowerCase().trim().includes(filters.name.toLowerCase().trim());
    });
  if (filters.code)
    metadata = metadata.filter(item => {
      return item.code && item.code.toLowerCase().trim().includes(filters.code.toLowerCase().trim());
    });
  if (filters.dataType)
    metadata = metadata.filter(item => {
      return item.dataType && item.dataType.toLowerCase().trim().includes(filters.dataType.toLowerCase().trim());
    });
  if (filters.entityType)
    metadata = metadata.filter(item => {
      return item.entityType && item.entityType.toLowerCase().trim().includes(filters.entityType.toLowerCase().trim());
    });

  const orderBy = [];
  if (pager.orderBy) orderBy.push(pager.orderBy);
  else orderBy.push('code', 'name');

  sortBy(metadata, orderBy, pager.direction);

  return metadata;
};

const MetadataListBrowser = ({ withExport }) => {
  const listFetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: METADATA_QUERY,
        name: 'metadata'
      },
      clientFilter: filterParams
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'name', caption: 'Metadata.Name' },
      { name: 'code', caption: 'Metadata.Code' },
      { name: 'dataType', caption: 'Metadata.DataType' },
      { name: 'entityType', caption: 'Metadata.Entity' },
      { name: 'actions', caption: 'Actions', width: 15 }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <ListBrowser name='metadata-browser' store={metadataStore} ItemsComponent={MetadataDetailsListContainer} columns={columns} />
      {!withExport && <ExportModalComponent store={metadataStore} options={listFetchingOptions} />}
      <ApolloFetchingComponent store={metadataStore} options={listFetchingOptions} />
    </Card>
  );
};

MetadataListBrowser.propTypes = {
  withExport: PropTypes.bool
};

export default MetadataListBrowser;
